export default "__VITE_ASSET__gIBq05Pm__"